import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { Status } from '../configurations/status.constant';
import { ResourceTypeUtils } from '../utils/resource-type.utils';

export const ValidateDate: ValidatorFn = (group: UntypedFormGroup) => {
    const resourceType = group.get('type').value;

    const hasRelevantType =
        ResourceTypeUtils.isPublicationJournalArticle(resourceType) ||
        ResourceTypeUtils.isPublicationBookReview(resourceType) ||
        ResourceTypeUtils.isPublicationBookChapter(resourceType) ||
        ResourceTypeUtils.isPublicationBook(resourceType) ||
        ResourceTypeUtils.isPublicationConferenceProceedings(resourceType);

    const isNotUnpublished =
        group.get('status').value &&
        group.get('status').value !== Status.UNPUBLISHED;

    const missingDate = !group.get('date').value;

    const hasSeasonFilled = group.get('seasonPublished').value;

    if (
        missingDate &&
        ((hasRelevantType && isNotUnpublished) || hasSeasonFilled)
    ) {
        return { validDate: true };
    }
    return null;
};
